import PageTitle from '../../../elements/PageTitle'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import List from '../../../components/Main/Group/List'
import GroupModal from '../../../components/Main/Group/GroupModal'

const { Content } = Layout

function Groups (props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>People</Breadcrumb.Item>
              <Breadcrumb.Item>Groups</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle title={'Groups'} subtitle={'List of all Groups.'} color={'#FF6138'} iconType={'solution'}/>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <GroupModal key={'group-modal'} {...props} />
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default withRouter(Groups)
